import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Button } from "@devhop/ui";
import { ArrowLeft, Download, HelpCircle } from "lucide-react";
import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { usePayrollQuery } from "../api/queries";
import { PayslipPdfPreviewContent } from "../ui/PayslipPdfPreviewContent";
import { useEffect } from "react";
import { HrTour } from "../tour/HrTour";
import { useHrTour } from "../tour/useHrTour";
import { payrollDetailTourSteps } from "../tour/hrTourSteps";

function handlePrint() {
  window.print();
}

export function PayrollDetailPage() {
  const { id } = useParams({ from: "/app/hr/payroll/$id" });
  const navigate = useNavigate();
  const search = useSearch({ from: "/app/hr/payroll/$id" }) as { print?: string };
  const { data, isLoading } = usePayrollQuery(id ?? "");
  const tour = useHrTour("hr-payroll-detail-tour-completed");

  useEffect(() => {
    if (search.print !== "1") return;
    if (!data) return;

    // Print after the payslip content mounts.
    const t = window.setTimeout(() => window.print(), 250);
    return () => window.clearTimeout(t);
  }, [search.print, data?.id]);

  if (isLoading || !data) {
    return (
      <>
        <Header />
        <Main>
          <p className="text-muted-foreground">ກຳລັງໂຫລດ...</p>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header className="print:hidden" />
      <Main>
        <div className="mb-6 flex flex-col gap-4 print:hidden sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <h1 className="font-bold text-2xl tracking-tight">
                ໃບຮັບເງິນເດືອນ — {data.periodLabel}
              </h1>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="size-8"
                onClick={tour.startTour}
                aria-label="ເລີ່ມທົດສອບການນຳທາງ"
                title="ເລີ່ມທົດສອບການນຳທາງ"
              >
                <HelpCircle className="size-4" />
              </Button>
            </div>
            <p className="mt-1 text-muted-foreground">
              ລາຍລະອຽດການຊຳລະເງິນເດືອນ
            </p>
          </div>
          <div className="flex gap-2">
            <Button
              size="sm"
              variant="outline"
              onClick={handlePrint}
            >
              <Download className="mr-1 size-4" />
              ດາວໂຫລດ / ພິມ
            </Button>
            <Button
              variant="default"
              onClick={() => navigate({ to: "/app/hr/payroll" })}
            >
              <ArrowLeft className="mr-1 size-4" />
              ກັບຄືນ
            </Button>
          </div>
        </div>

        <div data-tourid="hr-payroll-detail-content">
          <PayslipPdfPreviewContent payroll={data} />
        </div>

        <HrTour
          steps={payrollDetailTourSteps}
          run={tour.run}
          onCallback={tour.handleJoyrideCallback}
        />
      </Main>
    </>
  );
}
